import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import * as crypto from 'node:crypto';
import { Teacher } from '../teacher.js';

export const createTeacherMutation = registerMutation({
  operationName: 'createTeacherMutation',
  type: () => Boolean,
  params: [
    { name: 'userID', type: () => String },
    { name: 'firstName', type: () => String },
    { name: 'lastName', type: () => String },
    { name: 'school', type: () => String },
    { name: 'subjects', type: () => [String] },
    { name: 'email', type: () => String },
    { name: 'password', type: () => String },
    { name: 'language', type: () => String },
  ],
  resolve:
    (
      _userID: string,
      firstName: string,
      lastName: string,
      school: string,
      subjects: string[] | string,
      email: string,
      password: string,
      language = 'de',
      guestUserID?: string,
    ) =>
    async () => {
      const teacherId = crypto.randomUUID();
      const passwordHash = crypto.createHash('sha256').update(password).digest('hex');

      // Get the current user's ID for ownership
      const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
      const resolvedUserID = currentUser?._id || _userID;

      const normalizedSubjects = Array.isArray(subjects)
        ? subjects.map(subject => String(subject)).filter(subject => subject.trim().length > 0)
        : typeof subjects === 'string' && subjects.trim().length > 0
          ? [subjects.trim()]
          : [];

      const teacher = new Teacher({
        _id: teacherId,
        firstName,
        lastName,
        school,
        subjects: normalizedSubjects,
        email,
        passwordHash,
        userID: resolvedUserID,
        language: typeof language === 'string' && language.trim().length > 0 ? language : 'de',
      });

      const teacherCollection = await getCollection(Teacher);
      await teacherCollection.insertOne(teacher.toObject());

      return true;
    },
});
